import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Hub from "../guthrie/components/Hub";
import HubList from "../guthrie/components/HubList";

export default function DynamicProgram({ programId, program }) {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const hubId = queryParams.get("hub");

  const [programConfig, setProgramConfig] = useState(null);
  const [measureCharts, setMeasureCharts] = useState([]);
  const [programFlags, setProgramFlags] = useState({});
  const [aggregateValues, setAggregateValues] = useState(null);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [alertKeys, setAlertKeys] = useState([]);

  useEffect(() => {
    if (!program?.config) return;

    setProgramConfig(program.config);
    setMeasureCharts(program.config.measure_charts ?? []);

    const title = (program.config.title ?? "").trim().toUpperCase();
    setProgramFlags({
      isCHF: title === "CHF",
      isCKD: title === "CKD",
      isHTN: title === "HTN",
      isCOPD: title === "COPD",
    });

    const alerts = program.config.alerts ?? {};
    const deviceTypes = Array.from(
      new Set(
        Object.values(alerts).flatMap((alert) => alert?.device_types ?? [])
      )
    );
    setDeviceTypes(deviceTypes);

    setAlertKeys(Object.keys(alerts));
    setAggregateValues(program.config.aggregate_values ?? null);
  }, [program?.config]);

  if (!programConfig) {
    return <div>Loading program configuration...</div>;
  }

  return !hubId ? (
    <HubList
      programId={programId}
      measureCharts={measureCharts}
      deviceTypes={deviceTypes}
      isDynamicProgram
      {...programFlags}
    />
  ) : (
    <Hub
      hubId={hubId}
      measureCharts={measureCharts}
      programId={programId}
      aggregateValues={aggregateValues}
      deviceTypes={deviceTypes}
      alertKeys={alertKeys}
      isDynamicProgram
      {...programFlags}
    />
  );
}

DynamicProgram.propTypes = {
  programId: PropTypes.string.isRequired,
  program: PropTypes.shape({
    config: PropTypes.shape(),
  }),
};

DynamicProgram.defaultProps = {
  program: {},
};
